import { takeLatest } from 'redux-saga'
import { put, select } from 'redux-saga/effects'

import callAny from './helpers/call_any'
import actionTypes from 'redux/actions/actionTypes'
import goalsActions from 'redux/actions/goalsActions'
import { goalsSync } from 'sync'
import formatError from './helpers/error_formatter'
import oeqQuestionSelector from 'redux/selectors/oeq/oeq_question_selector'
import qsLessonParamsSelector from 'redux/selectors/qs/qs_lesson_params_selector'
import activityOriginSelector from 'redux/selectors/activity_creation/activity_origin_selector'
import presentationOriginTypes from 'helpers/enums/presentationOriginTypes'

function *getGoalsData() {
	try {
		const response = yield callAny(goalsSync.getGoalsData)
		yield put(goalsActions.fetched(response.payload.goals))
	} catch (error) {
		const serverError = formatError(error)
		yield put(goalsActions.failed(serverError))
	}
}

function *enableLessonTimeToClimb() {
	try {
		const qsLessonParamsData = yield select(qsLessonParamsSelector)
		const activityOrigin = yield select(activityOriginSelector)
		if (activityOrigin === presentationOriginTypes.GOALS) {
			yield callAny(goalsSync.enableLesson, qsLessonParamsData.presentationId)
			yield callAny(goalsSync.publishLesson, qsLessonParamsData.presentationId)
			yield put(goalsActions.timeToClimbEnableLessonSuccess())
		}
	} catch (error) {
		const serverError = formatError(error)
		yield put(goalsActions.timeToClimbEnableLessonFailed(serverError))
	}
}

function *createLessonOeq() {
	try {
		const response = yield callAny(goalsSync.createLessonOeq)
		yield put(goalsActions.oeqCreateLessonSuccess(response.payload))
	} catch (error) {
		const serverError = formatError(error)
		yield put(goalsActions.oeqCreateLessonFailed(serverError))
	}
}

function *enableLessonOeq() {
	try {
		const activityOrigin = yield select(activityOriginSelector)
		if (activityOrigin === presentationOriginTypes.GOALS) {
			const questionSelector = yield select(oeqQuestionSelector)
			yield callAny(goalsSync.publishLesson, questionSelector.presentationId)
			yield callAny(goalsSync.enableLesson, questionSelector.presentationId)
			yield put(goalsActions.oeqEnableLessonSuccess())
		}
	} catch (error) {
		const serverError = formatError(error)
		yield put(goalsActions.oeqEnableLessonFailed(serverError))
	}
}

export default [
	takeLatest([
		actionTypes.MY_LIBRARY_INITIALIZE,
		actionTypes.MY_LIBRARY_PREVIEW_DATA_FETCHED,
		actionTypes.MY_LIBRARY_DELETE_LESSON_SUCCESS,
		actionTypes.MY_LIBRARY_HOMEWORK_FETCHED,
	], getGoalsData),
	takeLatest(actionTypes.GAME_SAVE_SUCCESS, enableLessonTimeToClimb),
	takeLatest(actionTypes.GOALS_OEQ_CARD_CREATE_LESSON, createLessonOeq),
	takeLatest(actionTypes.OEQ_SAVE_OEQ_SUCCESS, enableLessonOeq),
]

export {
	getGoalsData,
	enableLessonTimeToClimb,
	createLessonOeq,
	enableLessonOeq,
}
